import React, { useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { TopNavContext } from '../../contexts/TopNavContext';
import { TranslationContext } from '../../contexts/TranslationContext';
import { ChangePasswordRequest, LoginClient } from '../../services/WebApiClient';
import { useClient } from '../../util/useClient';

export function PasswordEditModal(props: {
    onClose: () => void
}) {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [isBusy, setIsBusy] = useState(false);


    const tc = useContext(TranslationContext);
    let topNavContext = useContext(TopNavContext);
    const client = useClient(LoginClient);

    async function submit(evt: React.FormEvent) {
        evt.preventDefault();
        setIsBusy(true);
        try {
            await client.changePassword(new ChangePasswordRequest({
                oldPassword,
                newPassword
            }));
            props.onClose();
        }
        catch (ex) {
            //TODO Handle error
        } finally {
            setIsBusy(false);
        }
    }

    const isEnabled = !isBusy && !!newPassword;

    return (
        <Modal animation={false}
            show
            size="sm"
            onHide={props.onClose}>
            <Modal.Header closeButton>
                <h4>{tc.translator("change password modal header", "Skift password")}</h4>
            </Modal.Header>
            <form onSubmit={submit}>
                <Modal.Body>
                    <input id="username"
                        type="text"
                        defaultValue={topNavContext.currentUser?.username}
                        autoComplete="username"
                        style={{display:"none"}}
                    />
                    <div className="form-group">
                        <label htmlFor="current-password">
                            {tc.translator("change password modal old password", "Nuværende password")}
                        </label>
                        <input type="password"
                            id="current-password"
                            autoComplete="current-password"
                            className="form-control"
                            value={oldPassword}
                            autoFocus
                            onChange={evt => setOldPassword(evt.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="new-password">
                            {tc.translator("change password modal new password", "Nyt password")}
                        </label>
                        <input type="password"
                            id="new-password"
                            autoComplete="new-password"
                            className="form-control"
                            value={newPassword}
                            required
                            onChange={evt => setNewPassword(evt.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" disabled={!isEnabled} >
                        {tc.translator("change password modal button ", "Skift password")}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}
